import React, { Component, Fragment } from 'react'
import { Input } from 'hljd'
import styles from './formStyle'

class ImgCode extends Component {
  constructor(props) {
    super(props)
    this.state = {
      imgSrcIndex: 0
    }
  }

  changeImage = () => {
    this.setState({ imgSrcIndex: this.state.imgSrcIndex + 1 })
  }

  render() {
    const { value, onChange } = this.props
    const { imgSrcIndex } = this.state

    return (
      <Fragment>
        <Input
          style={{ width: 212 }}
          value={value}
          onChange={value => onChange(value)}
        />
        <img
          className={styles.codeImg}
          src={`/p/wedding/Web/Login/verify?v=${imgSrcIndex}`}
          onClick={this.changeImage}
        />
      </Fragment>
    )
  }
}

export default ImgCode
